import React from 'react'
import Font from '@cred/react-font'
import cashOutErrorImage from '../../../../assets/cashOutError.png'
import styles from './styles.scss'

const CashOutError = () => (
  <div className={styles.container}>
    <img className="mb-32" src={cashOutErrorImage} alt="cash-out-error" />
    <Font type="medium" weight="bold" className="mb-8">
      Your cash out amount is too high
    </Font>
    <Font type="bodySmall" color="lighter">
      Your loan amount plus cash out amount cannot exceed 80% of your home’s value.
    </Font>
    <Font type="bodySmall" color="lighter">
      Please adjust the values and try again.
    </Font>
  </div>
)

export default CashOutError
